import React from 'react';
import EditProductComponent from '../../../components/Admin/products/EditProductComponent';
import { useParams, useNavigate } from 'react-router-dom';

const EditProductPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/san-pham');
    }

    return <EditProductComponent productId={ params.productId } shouldRedirect={ () => redirect() }  />;
}

export default EditProductPage;